import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

import trackViewMutation from '../../requests/mutations/trackView';
import trackSearchMutation from '../../requests/mutations/trackSearch';
import updateLastSeenMutation from '../../requests/mutations/updateLastSeen';

export function useTrackingMutations() {
  const client = useApolloClient();

  const trackView = useCallback(
    (options) => client.mutate({ mutation: trackViewMutation, ...options }),
    [client]
  );
  const trackSearch = useCallback(
    (options) => client.mutate({ mutation: trackSearchMutation, ...options }),
    [client]
  );
  const updateLastSeen = useCallback(
    (options) =>
      client.mutate({ mutation: updateLastSeenMutation, ...options }),
    [client]
  );

  return [trackView, trackSearch, updateLastSeen];
}
